import type { AddButtonsCreator } from 'ricos-types';
import { Node_Type } from 'ricos-types';
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';

import { InsertPluginIcon } from './icons';
import { defaultCollapsibleList } from './tiptap/defaults';
import { COLLAPSIBLE_LIST_TYPE } from './types';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons: AddButtonsCreator = () => {
  return [
    {
      id: Node_Type.COLLAPSIBLE_LIST,
      icon: InsertPluginIcon,
      label: INSERT_PLUGIN_BUTTONS.COLLAPSIBLE_LIST,
      dataHook: INSERT_PLUGIN_BUTTONS.COLLAPSIBLE_LIST,
      tooltip: 'CollapsibleListPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,
      command: ({ editorCommands }) => {
        editorCommands.insertBlockWithBlankLines(COLLAPSIBLE_LIST_TYPE, defaultCollapsibleList);
        return true;
      },
      menuConfig: {
        tags: 'CollapsibleList_plugin_search_tags',
        group: 'advanced',
      },
    },
  ];
};
